export enum LabelBadge18Type {
  WUF = 'WUF',
  badge = 'badge',
  yellow = 'yellow',
  red = 'red',
  blue = 'blue',
  el70 = 'el70',
  gray = 'gray',
}
